/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const LockLocked: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7V9.5H9V7ZM7 9.5V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V9.5H17.5C19.1569 9.5 20.5 10.8431 20.5 12.5V18.5C20.5 20.1569 19.1569 21.5 17.5 21.5H6.5C4.84315 21.5 3.5 20.1569 3.5 18.5V12.5C3.5 10.8431 4.84315 9.5 6.5 9.5H7ZM5.5 12.5C5.5 11.9477 5.94772 11.5 6.5 11.5H17.5C18.0523 11.5 18.5 11.9477 18.5 12.5V18.5C18.5 19.0523 18.0523 19.5 17.5 19.5H6.5C5.94772 19.5 5.5 19.0523 5.5 18.5V12.5Z'
      fill='currentColor'
    />
  </React.Fragment>
)
